import { render, staticRenderFns } from "./addonsTables.vue?vue&type=template&id=54240083&"
import script from "./addonsTables.vue?vue&type=script&lang=js&"
export * from "./addonsTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports